module.exports = __webpack_public_path__ + "static/icons/icono-mis-beneficiarios.b1c07c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icono-mis-beneficiarios.svg
// module id = xBJr
// module chunks = 1